import { BASE_BUTTON_SIZE } from '../VBaseButton/constant';
import type { VButtonProps } from '../VButton/type';
import { new__cn as cn } from '../util';
import createTwStyle from '../util/createTwStyle';

const twStyle = createTwStyle<Pick<VButtonProps, 'size'>>();

export default twStyle({
  childWrapper: () => cn('px-2'),
  divider: ({ size = BASE_BUTTON_SIZE.MD }) =>
    cn('w-px bg-gray-500 aria-disabled:bg-gray-300', {
      'h-4': size === BASE_BUTTON_SIZE.XS,
      'h-5': size === BASE_BUTTON_SIZE.SM || size === BASE_BUTTON_SIZE.MD,
      'h-6': size === BASE_BUTTON_SIZE.LG,
    }),
});
